import AdminUpdatePaseinTreatment from "../../components/Admin/AdminTreatmentPasienUpdate";

export default function UpdatePasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminUpdatePaseinTreatment/>
    </div>
  );
}
